import { HttpClient } from '@angular/common/http';
import { Component, OnDestroy } from '@angular/core';
import { FEATURES } from '@ids-constants';
import { LicenseService } from '@ids-services';
import { BaseComponent as SharedBaseComponent } from '@microsec/components';
import { AppInjector } from '@microsec/utilities';
import moment from 'moment';
import { ConfirmationService, ContextMenuService, MessageService } from 'primeng/api';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { asyncScheduler, catchError, firstValueFrom, scheduled } from 'rxjs';

@Component({
  template: '',
  styleUrls: ['./base.component.scss'],
  providers: [DialogService, DynamicDialogRef, DynamicDialogConfig, MessageService, ConfirmationService, ContextMenuService],
})
export class BaseComponent extends SharedBaseComponent implements OnDestroy {
  constructor() {
    super();
  }

  override async prepareConfigs() {
    await super.prepareConfigs();
    const injector = AppInjector.getInjector();
    const httpClient = injector.get(HttpClient);
    this.isValidLicense.set(await this.checkIsValidLicense(httpClient));
  }

  checkConnectionFeatureEnabled(featureName: string) {
    return this.features?.[FEATURES.CONNECTIONS]?.[featureName] || false;
  }

  checkAnalyzerFeatureEnabled(featureName: string) {
    return this.features?.[FEATURES.ANALYZERS]?.[featureName] || false;
  }

  checkDeviceFeatureEnabled(featureName: string) {
    return this.features?.[FEATURES.DEVICES]?.[featureName] || false;
  }

  checkThreatFeatureEnabled(featureName: string) {
    return this.features?.[FEATURES.THREATS]?.[featureName] || false;
  }

  checkWorkflowFeatureEnabled(featureName: string) {
    return this.features?.[FEATURES.WORKFLOWS]?.[featureName] || false;
  }

  checkAssessmentFeatureEnabled(featureName: string) {
    return this.features?.[FEATURES.ASSESSMENTS]?.[featureName] || false;
  }

  checkReportFeatureEnabled(featureName: string) {
    return this.features?.[FEATURES.REPORTS]?.[featureName] || false;
  }

  getQuotaLimitation(featureName: string) {
    return this.features?.[FEATURES.QUOTAS]?.[featureName] || 0;
  }

  private async checkIsValidLicense(httpClient: HttpClient) {
    const licenseSrv = new LicenseService(httpClient);
    const licenses: any = await firstValueFrom(licenseSrv.getAllLicenses().pipe(catchError(() => scheduled([null], asyncScheduler))));
    if (!!licenses?.data?.length) {
      const latestLicense = this.util.sortObjectArray((licenses?.data as any[]) || [], 'modified', false, true)?.[0];
      const currentDate = moment();
      const startDate = moment(latestLicense.valids_at);
      const endDate = moment(latestLicense.expires_at);
      return !!currentDate.isBetween(startDate, endDate);
    }
    return false;
  }
}
